import { api } from "@lumberset/api-client";
import { MyTickets, requestReportProblem, supportQueries } from "@lumberset/support-ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";

/** The Tickets the signed-in Admin opened with "Report a problem". */
export const Route = createFileRoute("/_app/support/mine")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(supportQueries.tickets(api)),
  component: MyTicketsScreen,
});

function MyTicketsScreen() {
  const navigate = useNavigate();
  return (
    <>
      <Crumbs trail={[{ label: "Support", to: "/support" }, { label: "My tickets" }]} />
      <MyTickets
        client={api}
        title="My tickets"
        description="Problems you reported from the admin panel, newest first."
        onOpen={(id) => navigate({ to: "/support/tickets/$id", params: { id } })}
        onReport={requestReportProblem}
      />
    </>
  );
}
